/**
 * 생년월일(YYYYMMDD) 확인 — 오입력을 줄이려고 입력 즉시 "1995년 3월 2일 · 만 31세"로 풀어 보여 주고,
 * 달력에 없는 날짜나 나이가 말이 안 되는 값(만 15세 미만·만 80세 초과)은 막는다.
 */

/** 가입 가능한 나이 범위(만) — 치과 종사자·학생 기준 */
export const MIN_AGE = 15;
export const MAX_AGE = 80;

export interface BirthdayCheck {
    ok: boolean;
    /** ok 일 때 "1995년 3월 2일 · 만 31세" */
    text?: string;
    /** ok 가 아닐 때 안내 문구 */
    error?: string;
}

/** 오늘 기준 만 나이 */
export const ageOf = (year: number, month: number, day: number, today: Date = new Date()): number => {
    let age = today.getFullYear() - year;
    const beforeBirthday = today.getMonth() + 1 < month || (today.getMonth() + 1 === month && today.getDate() < day);
    if (beforeBirthday) age -= 1;
    return age;
};

export const checkBirthday = (yyyymmdd: string, today: Date = new Date()): BirthdayCheck => {
    if (!/^\d{8}$/.test(yyyymmdd)) return { ok: false, error: '생년월일을 YYYYMMDD 8자리로 입력해 주세요.' };
    const year = Number(yyyymmdd.slice(0, 4));
    const month = Number(yyyymmdd.slice(4, 6));
    const day = Number(yyyymmdd.slice(6, 8));
    const date = new Date(year, month - 1, day);
    if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) {
        return { ok: false, error: '달력에 없는 날짜예요. 생년월일을 다시 확인해 주세요.' };
    }
    const age = ageOf(year, month, day, today);
    if (age < MIN_AGE || age > MAX_AGE) {
        return { ok: false, error: `만 ${age}세로 계산돼요. 생년월일을 다시 확인해 주세요.` };
    }
    return { ok: true, text: `${year}년 ${month}월 ${day}일 · 만 ${age}세` };
};

/** 휴대폰 번호(숫자만) — 010 은 11자리, 옛 011·016~019 는 10~11자리 */
export const isMobilePhone = (digits?: string | null): boolean => !!digits && /^(010\d{8}|01[16789]\d{7,8})$/.test(digits);
